import React from 'react'
import { TrendingUp, TrendingDown, Minus } from 'lucide-react'
import { cn } from '@/lib/utils'

interface TrendIndicatorProps {
  value: string
  trend: 'up' | 'down' | 'stable'
  className?: string
}

export function TrendIndicator({ value, trend, className }: TrendIndicatorProps) {
  const getIcon = () => {
    switch (trend) {
      case 'up':
        return <TrendingUp className="h-3 w-3" />
      case 'down':
        return <TrendingDown className="h-3 w-3" />
      default:
        return <Minus className="h-3 w-3" />
    }
  }

  const getColor = () => {
    switch (trend) {
      case 'up':
        return 'text-emerald-600'
      case 'down':
        return 'text-red-600'
      default:
        return 'text-slate-600'
    }
  }

  return (
    <div className={cn('flex items-center gap-1', getColor(), className)}>
      {getIcon()}
      <span className="text-xs font-medium">{value}</span>
    </div>
  )
}